export default "__VITE_ASSET__FlNi7_ci__"